import ComponentsManager from "controllers/ComponentsManager";
import TransitionLines from "./TransitionLines";


export default new class {

	constructor() {
		ComponentsManager.register('transition_lines', TransitionLines);
	}


};
